import { render, staticRenderFns } from "./sa-404.vue?vue&type=template&id=76c49c56&scoped=true&"
import script from "./sa-404.vue?vue&type=script&lang=js&"
export * from "./sa-404.vue?vue&type=script&lang=js&"
import style0 from "./sa-404.vue?vue&type=style&index=0&id=76c49c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c49c56",
  null
  
)

export default component.exports